import manusingcomputer from './Man-Using-Computer.png'
import sideimage from './sideimage.png'
import Rect1 from './Rect1.png'
import CottonCorp from './Cotton_corp_add.png'
import India from './India.png'
import Contact from './Contact.png'
import profile_tools from './profile_tools.png'
import profile_tools1 from './profile_tools_1.png'
import Live from './Live.png'
import logo from './logo copy.png'
import barely from './bareliy.jpg'
import reciept_header from './Receipt-Header.png'
import footer_with_signatory_line from './Footer-with-Signatory-Line.png'
import login_side_img from './Login-Side-img.png'
import dashboard_img from './Dashboard-img.png'
import barely_black_bg_img from './Bareliy_Black_bg-img.png'
import Applied_Ministry from './Applied_Ministry.jpg'
import dashboard_bg_1 from './1.png'
import active_tenders from './Active-Tenders.png'
import DeactiveTenders from './Deactive-Tenders.png'
import Footer_img from './Footer.png'
import whatsapp from './WhatsApp.png'
import email from './Email.png'
import img1 from '../AboutUsImages/img1.png'
import img2 from '../AboutUsImages/img2.png'
import user1 from '../AboutUsImages/User1.png'
import user2 from '../AboutUsImages/User2.png'
import user3 from '../AboutUsImages/User3.png'
import aboutusbg from '../AboutUsImages/About-us-bg-img.png'
import ourteam from '../AboutUsImages/Our-Team.png'
import contactusbg from '../ContactUsImages/Contact-us-bg-img.png'
import location from '../ContactUsImages/Location.png'
import contact from '../ContactUsImages/Contact.png'
import email1 from '../ContactUsImages/Email.png'
import mayor1 from '../AboutUsImages/mayor-bareilly.jpg'
import mayor2 from '../AboutUsImages/municapal-bareilly.jpg'
import logout from '../LoginImages/Logout.png'
import aaplesarkar from './aaple-sarkar (1).png'
import Cidco from './CIDCO.png'
import cm from './cm.png'
import dcmdada from './dcm-dada.png'
import dcm from './dcm.png'
import digitalindia from './digitalindia.png'
import iasgovindraj1 from './ias-govindraj-1.png'
import iasgupta1 from './ias-gupta-1.png'
import maharashtra from './maharashtra.png'
import makeinindia from './makeinindia.png'
import mfs from './mfs.png'
import mumbai from './mumbai.png'
import NNgMRDA from './NNgMRDA.png'
import NMMRDA from './NNMRDA.png'
import NPMRDA from './NPMRDA.png'
import rmmm from './rmmm.png'
import uddlogowhite from './udd-logo-white.png'
import urbanbanner from './urban-banner.mp4'
import NMMRDA111 from './N-MMRDA111.png'
import BareliyBlackbgimg from './Bareliy_Black_bg-img.png'
import ReceiptWRD from './Receipt-WRD.png'
import india111 from './india111.png'

export { img1, img2, user1, user2, user3, aboutusbg, ourteam, contactusbg, location, contact, email1, whatsapp, email, Footer_img, DeactiveTenders, active_tenders, dashboard_bg_1, barely_black_bg_img, Applied_Ministry, dashboard_img, login_side_img, footer_with_signatory_line, reciept_header, barely, logo, Live, manusingcomputer, sideimage, Rect1, CottonCorp, India, Contact, profile_tools, profile_tools1, mayor1, mayor2, logout, aaplesarkar, Cidco, cm, dcm, dcmdada, digitalindia, iasgovindraj1, iasgupta1, maharashtra, makeinindia, mfs, mumbai, NNgMRDA, NMMRDA, NPMRDA, rmmm, uddlogowhite, urbanbanner,NMMRDA111 ,BareliyBlackbgimg,ReceiptWRD,india111}